import { ReportPeriodicity } from "../../../../models/report.dto";

const REPORT_EXECUTION_TABLE_TRANSLATION_PATH =
  "page.reports.execution.table.";

export const isMonthlyPeriodicity = (
  periodicity?: ReportPeriodicity | null,
) => periodicity === ReportPeriodicity.Monthly;

export const isDailyPeriodicity = (periodicity?: ReportPeriodicity | null) =>
  periodicity === ReportPeriodicity.Daily;

export const getReferenceColumnHeaderName = (
  t: (key: string, fallback?: string) => string,
  periodicity?: ReportPeriodicity | null,
) => {
  if (isMonthlyPeriodicity(periodicity)) {
    return t(
      REPORT_EXECUTION_TABLE_TRANSLATION_PATH + "monthReference",
      "Mês Referência",
    );
  }

  if (isDailyPeriodicity(periodicity)) {
    return t(
      REPORT_EXECUTION_TABLE_TRANSLATION_PATH + "dateReference",
      "Data Referência",
    );
  }

  return t(
    REPORT_EXECUTION_TABLE_TRANSLATION_PATH + "periodReference",
    "Período Referência",
  );
};
